// Cookie key value
export const ENVIRONMENT_COOKIE_KEY = 'ENVIRONMENT';

// Session storage key value
export const LOGIN_REDIRECT_KEY = 'LOGIN_REDIRECT';

export const FMH_NPI = '9999999999';
export const FMH_UNMANAGED_NPI = '9888888888';

/** Oops Member Types */
export const MemberTypes = {
    DEMO: 'demo',
    TEST: 'test',
    TRAIN: 'train',
    ALL: 'all',
} as const;
export type MemberType = (typeof MemberTypes)[keyof typeof MemberTypes];

export const MemberTypeOptions = [
    { value: MemberTypes.TEST, text: 'Test' },
    { value: MemberTypes.DEMO, text: 'Demo' },
    { value: MemberTypes.TRAIN, text: 'Train' },
];

export const BrandGenericDefault = [
    { name: 'Use Product Default', value: null },
    { name: 'Brand', value: true },
    { name: 'Generic', value: false },
];

export const MemberSelections = {
    NEW: 'new',
    EXISTING: 'existing',
    LOOKUP: 'lookup',
} as const;

export type MemberSelection = (typeof MemberSelections)[keyof typeof MemberSelections];

export const MemberSelectionOptions = [
    { value: MemberSelections.NEW, text: 'Create New Member' },
    { value: MemberSelections.EXISTING, text: 'Use Existing Member' },
    { value: MemberSelections.LOOKUP, text: 'Lookup Member' },
];
